'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.fetchAndRepeat = fetchAndRepeat;

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _tuner = require('./tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _webApiClientSingleton = require('./webApiClientSingleton');

var _webApiClientSingleton2 = _interopRequireDefault(_webApiClientSingleton);

var _Timer = require('./utils/Timer');

var _Timer2 = _interopRequireDefault(_Timer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTtl = 15 * 1000;
var timer = new _Timer2.default();
var guideId = void 0;
var itemToken = void 0;
var token = void 0;
var onNowPlayingChangedHandler = void 0;
var previousNowPlaying = void 0;
var fetchNowPlaying = void 0;

// Exported for testing
function fetchAndRepeat(shouldRepeat) {
  return fetchNowPlaying().then(function (params) {
    if (shouldRepeat) {
      setupNextRequest(shouldRepeat, (0, _get2.default)(params, 'ttl')); // eslint-disable-line no-use-before-define
    }
    return params;
  });
}

function setupNextRequest(shouldRepeat, ttl) {
  timer.start(function () {
    return fetchAndRepeat(shouldRepeat);
  }, ttl || defaultTtl);
}

function onNowPlayingFetched(response) {
  var nowPlaying = response.data.nowPlaying;
  token = response.data.token;

  if (!previousNowPlaying || previousNowPlaying.title !== nowPlaying.title) {
    previousNowPlaying = nowPlaying;
    onNowPlayingChangedHandler(nowPlaying);
  }

  return nowPlaying;
}

fetchNowPlaying = function fetchNowPlaying() {
  if (!guideId) {
    return _promise2.default.reject();
  }

  return _webApiClientSingleton2.default.instance.profile.nowPlaying(guideId, { token: token, itemToken: itemToken }).then(onNowPlayingFetched).catch(_noop2.default);
};

function poll(id, handler, shouldRepeat) {
  onNowPlayingChangedHandler = handler;

  guideId = id;
  itemToken = _tuner2.default.tune.itemToken;
  return fetchAndRepeat(shouldRepeat);
}

exports.default = {
  start: function start(id, handler) {
    return poll(id, handler, true);
  },
  stop: function stop() {
    timer.clear();
    previousNowPlaying = null;
    guideId = null;
  },
  fetchCurrentNowPlaying: function fetchCurrentNowPlaying(id) {
    return this.fetchOnce(id, _noop2.default);
  },
  fetchOnce: function fetchOnce(id, handler) {
    return poll(id, handler, false);
  }
};
//# sourceMappingURL=nowPlayingPoller.js.map